/*
    How a course, a lesson or a playlist is named everywhere in the editor: the tag first, then the
    title. The tag is what tells two records with the same title apart.
*/
export function titleWithTag(item: { title: string; tag?: string | null }) {
    return item.tag ? `[${item.tag}] ${item.title}` : item.title;
}
